import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Home from './Home';
import Login from './Login';
import AdminPanel from './AdminPanel';
import SobreNosotros from './SobreNosotros';
import ProductoDetalle from './ProductoDetalle';
 


export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/panel" element={<AdminPanel />} />
        <Route path="/sobre-nosotros" element={<SobreNosotros />} />
        {/* NUEVA RUTA */}
  <Route path="/producto/:id" element={<ProductoDetalle />} />
      </Routes>
    </Router>
  );
}